import axios from 'axios';

const api = axios.create({
  baseURL: 'https://ecodet-node.herokuapp.com/',
  //baseURL: 'http://192.168.0.161:3333/',
  // baseURL: 'http://localhost:3333/',
});

export default api;
